import i18n from '../../../../i18n/i18n';
import { LeadContentType, LeadType } from '../../../../store/api/leads-api';
import { IdValue } from '../../../../types/props';

export const formFields: IdValue[] = [
  {
    id: 'full_name',
    value: 'Полное имя',
  },
  {
    id: 'phone',
    value: 'Телефон',
  },
  {
    id: 'email',
    value: 'E-mail',
  },
  {
    id: 'sex',
    value: 'Пол',
  },
  {
    id: 'age',
    value: 'Возраст',
  },
];

export const ageOptions: IdValue[] = [
  {
    id: '4-10',
    value: '4-10',
  },
  {
    id: '11-15',
    value: '11-15',
  },
  {
    id: '16-22',
    value: '16-22',
  },
  {
    id: '23-30',
    value: '23-30',
  },
  {
    id: '31-38',
    value: '31-38',
  },
  {
    id: '39-45',
    value: '39-45',
  },
  {
    id: '46-55',
    value: '46-55',
  },
  {
    id: '56+',
    value: '56+',
  },
];

export const sexOptions: IdValue[] = [
  {
    id: 'm',
    value: 'Мужчина',
  },
  {
    id: 'f',
    value: 'Женщина',
  },
];

export const getContentFieldValue = (item: LeadType, type: LeadContentType) => {
  return item.content.find((item) => item.type === type)?.value || '';
};

export const getContentFields = (item: LeadType) => {
  const t = i18n.t;

  const name = getContentFieldValue(item, 'full_name') || t('Не указан');
  const phone = getContentFieldValue(item, 'phone') || t('Не указан');
  const email = getContentFieldValue(item, 'email') || t('Не указан');
  let sex = getContentFieldValue(item, 'sex') || t('Не указан');
  sex = sexOptions.find((item) => item.id === sex)?.value || t('Не указан');
  const age = getContentFieldValue(item, 'age') || t('Не указан');

  return {
    name,
    phone,
    email,
    sex,
    age,
  };
};
